import { render } from "./DirectoryView.vue?vue&type=template&id=61aabf1e&scoped=true"
import script from "./DirectoryView.vue?vue&type=script&lang=js"
export * from "./DirectoryView.vue?vue&type=script&lang=js"

import "./DirectoryView.vue?vue&type=style&index=0&id=61aabf1e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-61aabf1e"]])

export default __exports__